export function getExpiryTime(timeout) {
  const accessTokenDate = new Date();
  const accessTokenTime = accessTokenDate.getTime();
  const accessTokenExpireTime = accessTokenTime + timeout;
  accessTokenDate.setTime(accessTokenExpireTime);
  return accessTokenDate;
}